/**
 * utils使用 eg:this.utils.isApp()
 */

//判断是不是App
export const isApp = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  return ua.match(/jiaHuiKu_123213_appMark/i) == 'jiahuiku_123213_appmark'
}

//判断是不是App 安卓端
export const isAppAndroid = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  return (
    ua.match(/jiaHuiKu_123213_appMark_android/i) ==
    'jiahuiku_123213_appmark_android'
  )
}

//判断是不是微信
export const isWeiXin = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  return ua.match(/MicroMessenger/i) == 'micromessenger'
}

//判断是不是Android
export const isAndroid = () => {
  let u = navigator.userAgent
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
  return isAndroid
}

//判断是不是iOS
export const isIOS = () => {
  let u = navigator.userAgent
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  return isiOS
}
// 判断iOS底部是否出现黑色线条
export const isIOSBOTTOM = () => {
  var userAgent = navigator.userAgent
  var ios = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if (ios) {
    if (
      (screen.width === 320 && screen.height === 504) ||
      (screen.width === 375 && screen.height === 603) ||
      (screen.width === 414 && screen.height === 672)
    ) {
      return false
    } else {
      return true
    }
  } else {
    return false
  }
}
// 登录
export const isLogin = that => {
  let params = window.location.search
  params = params.replace(/&code=/, '&code1=') //code可能重复获取
  let url = window.location.pathname + params
  that.$router.push('/login?redirectUrl=' + url)
}
